export default __webpack_public_path__ + "assets/datenschutz.261095a7.pdf";